const COLOR_REQUESTS = '#3b82f6';
const COLOR_ERRORS = '#dc3545';
const COLOR_BANDWIDTH = '#30d7e3';
const COLOR_LATENCY = '#bbbbbb';

export default function UsageStatCards({ summary }) {
  const totalRequests = summary?.total_requests ?? 0;
  const errorRate = summary && totalRequests > 0
    ? ((summary.total_errors / totalRequests) * 100).toFixed(2)
    : '0.00';
  const avgLatency = summary?.avg_latency ?? 0;
  const kbytesPerRequest = summary && totalRequests > 0
    ? summary.total_bytes / 1024 / totalRequests
    : 0;

  return (
    <div className="mb-4 flex flex-wrap gap-4 sm:gap-6 rounded-2xl border border-cyan-100 bg-white p-3 sm:p-4">
      <div className="flex flex-1 min-w-[130px] flex-col gap-1 sm:gap-3">
        <div className="text-base text-slate-500">Total API Calls</div>
        <div className="break-all text-2xl font-bold" style={{ color: COLOR_REQUESTS }}>
          {totalRequests.toLocaleString()}
        </div>
      </div>
      <div className="flex flex-1 min-w-[130px] flex-col gap-1 sm:gap-3">
        <div className="text-base text-slate-500">Error Rate</div>
        <div className="text-2xl font-bold" style={{ color: COLOR_ERRORS }}>
          {errorRate}%
        </div>
      </div>
      <div className="flex flex-1 min-w-[130px] flex-col gap-1 sm:gap-3">
        <div className="text-base text-slate-500">KB/request</div>
        <div className="flex text-2xl font-bold" style={{ color: COLOR_BANDWIDTH }}>
          {kbytesPerRequest.toLocaleString(undefined, { maximumFractionDigits: 0 })} KB
        </div>
      </div>
      <div className="flex flex-1 min-w-[130px] flex-col gap-1 sm:gap-3">
        <div className="text-base text-slate-500">Avg Latency</div>
        <div className="flex text-2xl font-bold" style={{ color: COLOR_LATENCY }}>
          {avgLatency.toLocaleString(undefined, { maximumFractionDigits: 0 })}ms
        </div>
      </div>
    </div>
  );
}
